exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb10[data-v-10b781ca]{margin-bottom:10px}.color-tip[data-v-10b781ca]{color:#e6a23c;font-size:12px}", ""]);

// exports
